import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { useRedeemPromotion } from 'blocks/Pricing';
import useOnMount from 'hooks/useOnMount';
import { isFetchErrorSelector } from 'redux/modules/display-pref';
import { getMyDisplayPref } from 'redux/modules/display-pref/actions';
import { getUserPersonalFonts } from 'redux/modules/fonts/actions';
import { showError } from 'redux/modules/notification/actions';
import { loadPricingData } from 'redux/modules/pricing';
import { appHomeSelector } from 'redux/modules/router';
import { getMyUserPref } from 'redux/modules/user-pref/actions';
import { clearWizardExport } from 'redux/modules/wizard-export/actions';
import { Dispatch } from 'redux/types';
import { WIZARD_PAGE_LOADER_ERROR_ID } from './constants';
import WizardPage from './WizardPage';

export type WizardPageLoaderProps = {};

const WizardPageLoader: React.FC<WizardPageLoaderProps> = () => {
  // Legacy logic defines the loading state based on the progress of the
  // "getMyDisplayPref" request. Some wizards (e.g. AudioWizard) allow the user
  // to use them anonymously and then authenticate right at the end. If, at that point,
  // we issue a request to get the user's display preferences, the isLoading prop
  // injected into this component from redux will change, affecting what this component
  // renders on screen. This state value makes sure that doesn't happen.
  const [isLoaded, setIsLoaded] = useState(false);

  const hasError = useSelector(isFetchErrorSelector);
  const fallbackUrl = useSelector(appHomeSelector);

  const dispatch = useDispatch<Dispatch>();

  useRedeemPromotion();

  useOnMount(async () => {
    try {
      dispatch(clearWizardExport());

      await dispatch(getMyDisplayPref());
      await dispatch(getMyUserPref());
      await dispatch(getUserPersonalFonts());
      await dispatch(loadPricingData({ force: true }));

      setIsLoaded(true);
    } catch (err) {
      dispatch(
        showError({
          message: err.message,
          code: err.code,
          id: WIZARD_PAGE_LOADER_ERROR_ID,
        }),
      );
    }
  });

  if (hasError) {
    return <Redirect to={fallbackUrl} />;
  }

  return <div className="wizard-page">{!isLoaded ? null : <WizardPage />}</div>;
};

export default WizardPageLoader;
